module.exports = __webpack_public_path__ + "img/m-banner-xzdvxwdm-tr-TR.9349687d.jpg";